import { AgxSpacer } from '@urbanx/agx.ui-components2';
import { useTopPerformers } from 'features/reportingDashboard/topPerformersReducer';
import SidebarLeaderboard from './components/SidebarLeaderboard/SidebarLeaderboard';

const CampaignsViewSidebar = () => {
  const { stats, loading: loadingTopPerformers } = useTopPerformers();

  const agentLeaderboardStat = stats?.individualAndTeamRankings;
  const agencyLeaderboardStat = stats?.agencyRankings;

  return (
    <AgxSpacer className="bodySectionSideBarContainer sidebarGap" direction="vertical" fill>
      <AgxSpacer className="sidebarLeaderboard columnFill first-leaderboard">
        <SidebarLeaderboard
          loading={loadingTopPerformers}
          leaderboardStats={agencyLeaderboardStat}
          boardName="Partners"
        />
      </AgxSpacer>
      <AgxSpacer className="sidebarLeaderboard columnFill">
        <SidebarLeaderboard
          loading={loadingTopPerformers}
          leaderboardStats={agentLeaderboardStat}
          boardName="Performers"
        />
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default CampaignsViewSidebar;
